// extracted by mini-css-extract-plugin
export default {"layout":"_0aYKV0G1--SplitLayout_layout__OSHb5","left":"_0aYKV0G1--SplitLayout_left__kHvhA","right":"_0aYKV0G1--SplitLayout_right__P7b4m"};